import React, { useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
// import { handleDeleteImage } from "../canvasFunction";
import "./canvasDataDetail.css";
import {
  handleAddObstacle,
  handleAddStructure,
  handlePolygon,
  handleDrag,
} from "../DSFunction";
import { kiloToMegaWatt } from "../../summaryReport/projectOverview";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { handleDeleteImg } from "../structurePlacementFunction/subFunc";

export default function CanvasDataDetails({
  selectedImage,
  setSelectedImage,
  setZoomValue,
  zoomValue,
  setDragPos,
  dragPos,
  setDrag,
  setPoints,
}) {
  const roofInfo = useSelector((state) => state.roof, shallowEqual);
  const gridInfo = useSelector((state) => state.grid);
  const designParameter = useSelector((state) => state.designParameter);
  const quantityInfo = useSelector((state) => state.quantity);
  const [icon, setIcon] = useState(null);
  const dispatch = useDispatch();

  const zoomIn = () => {
    if (zoomValue < 4) {
      setZoomValue(zoomValue + 0.075);
    }
  };
  const zoomOut = () => {
    if (zoomValue > 1) {
      setZoomValue(zoomValue - 0.075);
    }
  };
  const resetTransform = () => {
    setZoomValue(1);
    setDragPos({ x: 0, y: 0 });
  };

  let roofData = quantityInfo?.roofData ? quantityInfo.roofData : [];
  let roofInformation =
    roofData && roofData.length > 0 ? roofData[quantityInfo.roofNo] : [];

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  let data = [];
  let exportEnergy = 0;
  let importEnergy = 0;
  let pvGeneratedEnergy = 0;
  let totalCapacity = 0;
  let pvModule = 0;
  let shadingLosses = 0;
  let azimuthLosses = 0;
  let tiltLosses = 0;
  let totalSquareMeter = 0;
  let pvYeild = 0;

  const list = roofInformation.multipleStructure;

  if (roofData.length > 0 && roofInformation.images.length > 0) {
    if (roofInformation.structureType === "Single") {
      totalCapacity = Number(roofInformation.totalKilowatt);
      pvModule = roofInformation.pvModule;
    } else {
      const totalKilowatt = Number(
        list.reduce((total, data) => total + data.totalKilowatt, 0).toFixed(1)
      );
      totalCapacity += Number(totalKilowatt);

      const noOfModule = Object.values(list).reduce(
        (sum, value) => sum + value.pvModule,
        0
      );
      pvModule += noOfModule;
    }
    for (let j = 0; j < 12; j++) {
      let value = roofInformation.actualGeneration[j];
      pvGeneratedEnergy += value;
      value -= roofInfo.value.financialAnalysis[month[j]];
      data.push(value);
      if (value >= 0) {
        exportEnergy += value;
      } else {
        importEnergy += -value;
      }
    }
    shadingLosses = Object.values(roofInformation.shadingLosses).reduce(
      (sum, value) => sum + value,
      0
    );
    tiltLosses = Object.values(roofInformation.tiltAngleLosses).reduce(
      (sum, value) => sum + value,
      0
    );
    azimuthLosses = Object.values(roofInformation.azimuthLosses).reduce(
      (sum, value) => sum + value,
      0
    );

    let panelInfo = panelInformation.find(
      (item) => item.brand === roofInformation.module
    );
    let panel = panelInfo.panelType.find(
      (item) => item.name === roofInformation.moduleType
    );
    if(panel){
      totalSquareMeter = pvModule * panel.height * panel.width;
    }
    pvYeild = pvGeneratedEnergy / totalCapacity;
  }

  let moduleConfiguration = [
    {
      title: "Total System:",
      value: `${kiloToMegaWatt(totalCapacity)}`,
    },
    {
      title: "PV Module:",
      value: `${pvModule}`,
    },
    {
      title: "PV covered area:",
      value: `${Number(totalSquareMeter.toFixed(1)).toLocaleString(
        "en-US"
      )} ㎡`,
    },
    {
      title: "Specific PV yield:",
      value: `${Number(pvYeild.toFixed()).toLocaleString("en-US")} kWh/kWp`,
    },
    {
      title: "PV yearly yeild:",
      value: `${kiloToMegaWatt(Number(pvGeneratedEnergy.toFixed()))}h`,
    },
    {
      title: "Shading Losses:",
      value: `${kiloToMegaWatt(Number(shadingLosses.toFixed()))}h`,
    },
    {
      title: "Tilt Angle Losses:",
      value: `${kiloToMegaWatt(Number(tiltLosses.toFixed()))}h`,
    },
    {
      title: "Azimuth Losses:",
      value: `${kiloToMegaWatt(Number(azimuthLosses.toFixed()))}h`,
    },
    {
      title: "Total Losses:",
      value: `${kiloToMegaWatt(
        Number((azimuthLosses + tiltLosses + shadingLosses).toFixed())
      )}h`,
    },
    {
      title: "Import Energy:",
      value: `${kiloToMegaWatt(Number(importEnergy.toFixed()))}h`,
    },
    {
      title: "Export Energy:",
      value: `${kiloToMegaWatt(Number(exportEnergy.toFixed()))}h`,
    },
  ];

  const [showSimulation, setShowSimulation] = useState(false);

  // WEATHER STATION API
  

  return (
    <>
      <div className="canvasIcon">
        <div className="iconBox">
          <img
            src="../images/icons/polygonAdd.svg"
            alt="polygon"
            onClick={() =>
              handlePolygon({ setDrag, dispatch, setPoints, designParameter })
            }
            onMouseEnter={() => setIcon("Draw Roof")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "Draw Roof" && <span className="toottips">Draw Roof</span>}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/addObstacle.svg"
            alt="polygon"
            onClick={() =>
              handleAddObstacle({
                setDrag,
                setPoints,
                dispatch,
                designParameter,
              })
            }
            onMouseEnter={() => setIcon("draw obstacle")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "draw obstacle" && (
            <span className="toottips">Draw Obstacle</span>
          )}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/pan.svg"
            alt="pan"
            onClick={() => handleDrag({ dispatch, setDrag })}
            onMouseEnter={() => setIcon("pan")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "pan" && <span className="toottips">Pan</span>}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/zoomin.svg"
            alt="polygon"
            onClick={() => zoomIn()}
            onMouseEnter={() => setIcon("zoomIn")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "zoomIn" && <span className="toottips">Zoom In</span>}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/zoomout.svg"
            alt="polygon"
            onClick={() => zoomOut()}
            onMouseEnter={() => setIcon("zoomOut")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "zoomOut" && <span className="toottips">Zoom Out</span>}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/reset.png"
            alt="reset icon"
            onClick={() => resetTransform()}
            onMouseEnter={() => setIcon("reset")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "reset" && <span className="toottips">Reset Position</span>}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/addStructure.svg"
            alt="Add Structure"
            onClick={() =>
              handleAddStructure({
                gridInfo,
                dispatch,
                roofInformation,
                setDrag,
              })
            }
            onMouseEnter={() => setIcon("Add Structure")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "Add Structure" && (
            <span className="toottips">Add Structure</span>
          )}
        </div>
        <div className="iconBox">
          <img
            src="../images/icons/deleteStructure.svg"
            alt="Delete Structure"
            onClick={() =>
              handleDeleteImg({
                setDrag,
                selectedImage,
                setSelectedImage,
                dispatch,
                roofInfo,
                quantityInfo,
                designParameter,
              })
            }
            onMouseEnter={() => setIcon("Delete Structure")}
            onMouseLeave={() => setIcon(null)}
          ></img>
          {icon === "Delete Structure" && (
            <span className="toottips">Delete Structure</span>
          )}
        </div>
      </div>

      <div className="sim-btn">
        <h5 onClick={() => setShowSimulation(!showSimulation)}>
          Simulation Info
        </h5>
        {showSimulation && (
          <div className="sim-Info">
            <div className="dataSpam">
              <h2>{}</h2>
              <span>{}</span>
            </div>
            {moduleConfiguration.map((item, i) => {
              return (
                <div className="dataSpam" key={i}>
                  <h2>{item.title}</h2>
                  <span>{item?.value || 0}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
